import React from "react";
import dayjs from "dayjs";
import OrganizerPillSelect from "../../components/OrganizerPillSelect";
import { SingleDatePickerPill } from "../../../pages/reservas/components/ReservaShared";
import CourtSeriesDateList from "../../reservas/components/CourtSeriesDateList";
import { MAX_SERIES_WEEKS, maxSeriesDateTo, pluralTurnos } from "../../reservas/components/courtSeriesModel";
import { INTERVAL_OPTIONS, seriesHint } from "./turnoFijoModel";
import "../../reservas/components/CourtSeries.css";

/* Bloque "Turno fijo (se repite)" de la reserva nueva: el mismo `csr-fixed` de Canchas, con el intervalo en semanas
   ("Cada") y el profesional en la frase. Todo el estado vive en useTurnoFijo / useSerieFija; acá solo se dibuja. Canchas lo usa con `sinProfesional`. */

const TurnoFijoBlock = ({ ctl, date, slotStart, professionalId, professionalName, desactivado = false, sinProfesional = false, faltaTexto = "Elegí los servicios y un horario." }) => {
  const { fixed, alternar, intervalWeeks, setIntervalWeeks, dateTo, cambiarFin, rangeError, listo, preview, current, availableCount, skipped, verFechas } = ctl;
  const weekday = dayjs(date).day();

  return (
    <div className="csr-fixed">
      <label className="csr-check">
        <input type="checkbox" className="zr-check" checked={fixed} disabled={desactivado} onChange={(e) => alternar(e.target.checked)} />
        <span>Turno fijo (se repite)</span>
      </label>
      {fixed && (
        <>
          <div className="pu-grid-2">
            <div className="ef-field">
              <span className="ef-label" id="tf-cada-label">Cada</span>
              <OrganizerPillSelect
                id="tf-cada"
                labelledBy="tf-cada-label"
                value={intervalWeeks}
                options={INTERVAL_OPTIONS}
                onChange={(v) => setIntervalWeeks(Number(v))}
              />
            </div>
            <div className="ef-field">
              <span className="ef-label">Hasta</span>
              <SingleDatePickerPill
                value={dayjs(dateTo)}
                onChange={cambiarFin}
                minDate={dayjs(date)}
                maxDate={maxSeriesDateTo(date)}
                ariaLabel="Fecha hasta"
              />
            </div>
          </div>
          <p className="csr-hint">
            {seriesHint({ intervalWeeks, weekday, slotStart, professionalName, maxWeeks: MAX_SERIES_WEEKS })}
          </p>
          {rangeError && (
            <span className="csr-error" role="alert">
              {rangeError}
            </span>
          )}
          <div>
            <button type="button" className="zr-btn zr-btn--soft" disabled={!listo || Boolean(rangeError) || Boolean(preview?.loading)} onClick={verFechas}>
              {preview?.loading ? "Revisando..." : "Ver fechas"}
            </button>
            {!sinProfesional && !professionalId ? (
              <span className="csr-hint"> Un turno fijo necesita un profesional: elegí uno en lugar de “Sin preferencia”.</span>
            ) : !listo ? (
              <span className="csr-hint"> {faltaTexto}</span>
            ) : null}
          </div>
          {preview?.error && preview.key === ctl.key && (
            <span className="csr-error" role="alert">
              {preview.error}
            </span>
          )}
          {current ? (
            <>
              <p className="csr-count" role="status">
                {availableCount > 0
                  ? `${pluralTurnos(availableCount)} disponible${availableCount === 1 ? "" : "s"} de ${current.dates.length}.`
                  : "Ninguna de las fechas está disponible."}
              </p>
              <CourtSeriesDateList dates={current.dates} />
            </>
          ) : (
            listo &&
            !preview?.loading &&
            !preview?.error && <p className="csr-hint">Revisá las fechas con “Ver fechas” antes de crear el turno fijo.</p>
          )}
          {skipped && skipped.length > 0 && (
            <>
              <p className="csr-count">Fechas omitidas</p>
              <CourtSeriesDateList dates={skipped} label="Fechas omitidas" />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default TurnoFijoBlock;
